/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Alert from '@material-ui/lab/Alert';
import { checkExamBeginTime } from '../../../../../redux/actions/examType1Actions';

const Warning = ({
  additionalTime,
  currentExam,
  sendAnswer,
  alreadySent,
  setAlreadySent,
  examType,
  answerDate,
}) => {
  const [warningOpen, setWarningOpen] = useState(false);
  const warningAlreadyShownRef = useRef(false);
  const alreadySentRef = useRef(alreadySent);

  useEffect(() => {
    alreadySentRef.current = alreadySent;
  }, [alreadySent]);

  useEffect(() => {
    if (!currentExam || !currentExam._id || answerDate !== null) {
      return undefined;
    }

    const examId = currentExam._id;
    const duration = currentExam.duration || 90;

    const interval = setInterval(() => {
      const remainingTime = checkExamBeginTime(additionalTime, duration, examId);

      if (remainingTime == null) {
        return;
      }

      if (
        remainingTime > 0
        && remainingTime <= 5 * 60 * 1000
        && !warningAlreadyShownRef.current
      ) {
        setWarningOpen(true);
        warningAlreadyShownRef.current = true;
      }

      if (remainingTime <= 0 && !alreadySentRef.current && examType === 2) {
        alreadySentRef.current = true;
        sendAnswer();
        setAlreadySent(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [
    additionalTime,
    currentExam,
    answerDate,
    examType,
    sendAnswer,
    setAlreadySent,
  ]);

  return (
    <Snackbar
      open={warningOpen}
      onClose={() => setWarningOpen(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      role="presentation"
    >
      <Alert
        severity="warning"
        variant="filled"
        onClose={() => setWarningOpen(false)}
        role="alert"
      >
        Attention votre examen prendra fin dans 5 minutes.
      </Alert>
    </Snackbar>
  );
};

Warning.propTypes = {
  additionalTime: PropTypes.number.isRequired,
  currentExam: PropTypes.object,
  sendAnswer: PropTypes.func.isRequired,
  alreadySent: PropTypes.bool.isRequired,
  setAlreadySent: PropTypes.func.isRequired,
  examType: PropTypes.number.isRequired,
  answerDate: PropTypes.any,
};

Warning.defaultProps = {
  currentExam: null,
  answerDate: null,
};

const actionCreators = {};

function mapState(state) {
  const { additionalTime } = state.user.userData;
  return {
    additionalTime,
  };
}

export default connect(mapState, actionCreators)(Warning);
